import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { MarkersInfoColors } from "../WinLineInfoMarkers";

// namespace SlotGames {
export class BurningFruits5_Responsive extends SlotGameType1_Responsive {


    protected override helpFactory: IHelpFactory = new BurningFruits5_HelpFactory();

    //LED COLOR
    protected override ColorLed: string = "250,0,0\n";

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "BurningFruits5") {
        super(multigameParams, initData, gameName);
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }

    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }

    protected override colorLineMarkers: MarkersInfoColors =
        {
            MarkerbackgroundColor: "linear-gradient(90deg, rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

}

//Help Colorized
class BurningFruits5_HelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new BurningFruits5_Help(params);
    }
}

class BurningFruits5_Help extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
// }
